<template>
  <div class="yesno">
    <span
      v-for="[key, text] in Object.entries(options || defaultOptions)"
      :key="key"
      class="yesno__option"
      :class="{ yesno__option_active: value === key }"
      @click="$emit('input', key)"
    >
      {{ text }}
    </span>
  </div>
</template>

<script>
export default {
  props: ['value', 'options'],
  computed: {
    defaultOptions() {
      return {
        yes: this.$t('YES'),
        no: this.$t('NO'),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.yesno {
  display: flex;

  &__option {
    text-transform: capitalize;
    padding: 6px 10px;
    flex-grow: 1;
    border: 1px solid #e5e5e5;
    position: relative;
    cursor: pointer;

    &_active {
      background-color: $lighter-primary;
      border-color: lighten($primary, 25);
      z-index: 1;
      cursor: default;
    }

    &:first-child {
      border-radius: 2px 0 0 2px;
    }

    &:last-child {
      border-radius: 0 2px 2px 0;
      margin-left: -1px;
    }
  }
}
</style>
